module.exports = __webpack_public_path__ + "assets/947d3844062a0b378c321aa4a7556216.jpg";